





















































































import {Component, Ref} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsInspector from "@/design-system/patterns/Inspector/JdsInspector.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiCodeBlock from "@/components/JdiCodeBlock.vue"
import JdsDialog from "@/design-system/patterns/Dialog/JdsDialog.vue"

@Component({
    components: {
        JdsDialog,
        JdiCodeBlock, JdsGlyph, JdiDocs, JdsButton, JdsInspector, JdiStatus, JdiContent, JdiPreview}
})
export default class Dialog extends Vue {
    @Ref() dialogEl!: JdsDialog
    textValue = ''
    selectValue = '1'

    open () {
        this.dialogEl.open()
            .then((e)=> console.log('Closed'))
            .catch((e)=> console.log('Cancelled'))
    }

    close () {
        this.dialogEl.close()
    }

    flip() {
        this.dialogEl.flip()
    }
}
